import React from "react";
import { motion } from "framer-motion";
import work from "./Work.json";
import "./Work.scss";

function Work() {
  return (
    <div className="work section-shell">
      <div className="section-heading">
        <div>
          <span className="section-kicker">Experience</span>
          <h2>EagleView engineering progression</h2>
        </div>
        <p>
          Software Engineer II scope across EV One, Horizon, validation, deliverable generation, EagleEye, and production
          triage, with earlier ownership across Property Viewer, EV Viewer 2.0, and TD Solar reliability.
        </p>
      </div>

      <div className="work__timeline">
        {work.map((item, index) => (
          <motion.article
            className="work__item"
            key={item.id}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.48, delay: index * 0.08 }}
          >
            <div className="work__marker" aria-hidden="true">
              <span>{String(index + 1).padStart(2, "0")}</span>
            </div>

            <div className="work__content">
              <div className="work__header">
                <div>
                  <h3>{item.title}</h3>
                  <p>
                    {item.company} · {item.location}
                  </p>
                </div>
                <span>{item.date}</span>
              </div>

              <p className="work__summary">{item.summary}</p>

              <ul>
                {item.highlights.map((highlight) => (
                  <li key={highlight}>{highlight}</li>
                ))}
              </ul>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  );
}

export default Work;
